import http from './http';

class NotificationsService {
  static getNotifications() {
    return http.get('/notifications');
  }
}
export default NotificationsService;
